import { useCommonWebsocket } from '@common/api/ws/hooks/useCommonWebsocket';
export var useChatWebsocket = function (cb) {
    useCommonWebsocket('chat', cb);
};
